export enum enumEnvironmentName {
  LOCAL_DEV,
  LOCAL,
  DEV,
  TEST,
  STAGE,
  PROD,
}
